import React from 'react';

import withPensionExpertTier from '../../util/pensionExpertTier/withPensionExpertTier';

import NotificationBanner from '../NotificationBanner/NotificationBanner';

const TaxResidencyNotification = ({ isPoolExpert, expertRoleTitle }) => {
  return (
    <NotificationBanner
      alertCategory={'Red'}
      alertTitle={'UK residency'}
      expandableAlertDescription={isPoolExpert
        ? 'As you have told us you are not a UK resident we need to speak to you urgently about your pension. Please contact our Pension Experts.'
        : `As you have told us you are not a UK resident we need to speak to you urgently about your pension. Please contact your dedicated ${expertRoleTitle}.`}
      ctaButtonOptions={{
        label: isPoolExpert ? 'Message our Pension Experts' : `Message my ${expertRoleTitle}`,
        to: 'inbox/new-message',
      }}
    />
  );
};

export default withPensionExpertTier(TaxResidencyNotification);
